import { createFileRoute } from '@tanstack/react-router';

import { getTeamMemberQueryOption } from '@/_pages/team-members/api-service';
import Loading from '@/_pages/team-members/marketing/loading';

export const Route = createFileRoute('/_private/team-members/_template/$id/marketing')({
  loader: (opts) => opts.context.queryClient.ensureQueryData(getTeamMemberQueryOption(opts.params.id)),
  staticData: {
    pageTitle: 'Marketing',
    tabKey: 'team-member/marketing',
  },
  pendingComponent: Loading,
});
